import React from 'react';
import ProductsCarousel from '../../../../product-carousel/products-carousel';
import Skeleton from 'react-loading-skeleton';
import { useFetch } from 'hooks/use-fetch';
import { InView } from 'react-intersection-observer';
import Link from 'atomic/link';

const ProductWidgetSimilarProduct: React.FC<{
    isMobile: boolean;
    categoryUrl: string;
    productId: number;
    isSlideIndicator?: boolean;
}> = ({ isMobile, categoryUrl, productId, isSlideIndicator = false }) => {
    const { data, error, get } = useFetch(`/api/product/similar-products?id=${productId}`, { method: 'GET' });

    const onView = (inView: boolean): void => {
        if (inView) {
            get();
        }
    };

    let similarProducts = data;

    if (similarProducts !== null && error) {
        similarProducts = null;
    }

    if (similarProducts && similarProducts.items.length === 0) {
        similarProducts = null;
    }

    return (
        <InView triggerOnce={true} as="div" onChange={onView}>
            <ProductsCarousel
                headerTitle="Produkty polecane dla Ciebie"
                products={similarProducts}
                isMobile={isMobile}
                isSlideIndicator={isSlideIndicator}
            >
                <Link href={categoryUrl}
                    type="button"
                    size="lg"
                    color="transparent-secondary"
                    weight="500"
                >
                    Sprawdź wszystkie ({(similarProducts === null)
                        ? <Skeleton width={40} />
                        : similarProducts.count})
                </Link>
            </ProductsCarousel>
        </InView>
    );
};

export default ProductWidgetSimilarProduct;
